import clientAxios from './../../config/axios';

export const getAllWarehouses = (
  token: string,
  { filter, pagination }: any
) => {
  const filterTmp = filter ?? '';
  const complement = pagination?.page
    ? `page=${pagination.page}&items_per_page=${pagination.rowsPerPage}${filterTmp}`
    : `all=1${filterTmp}`;
  const url = `/warehouses?country=${process.env.REACT_APP_ENV_COUNTRY}&${complement}`;
  return clientAxios.get(url, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const updateWarehouse = (token: string, warehouse: any) => {
  const url = `/warehouses?country=${process.env.REACT_APP_ENV_COUNTRY}&id=${warehouse.id}`;
  return clientAxios.put(url, warehouse, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const createWarehouse = (token: string, warehouse: any) => {
  const url = `/warehouses?country=${process.env.REACT_APP_ENV_COUNTRY}`;
  return clientAxios.post(url, warehouse, {
    headers: { Authorization: `Bearer ${token}` },
  });
};
